var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6Versn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 43,
    stroke: "#D9D9D9",
    strokeWidth: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 110H70V120C70 122.761 67.7614 125 65 125H60C57.2386 125 55 122.761 55 120V110Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 5C55 2.23858 57.2386 0 60 0H65C67.7614 0 70 2.23858 70 5V15H55V5Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60C0 57.2386 2.23858 55 5 55H15V70H5C2.23858 70 0 67.7614 0 65V60Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 55H121C123.761 55 126 57.2386 126 60V65C126 67.7614 123.761 70 121 70H111V55Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 23.4849L99.1513 16.495C101.126 14.5647 104.292 14.6009 106.222 16.5757L109.717 20.1513C111.647 22.1261 111.611 25.2917 109.636 27.2219L102.485 34.2118L92 23.4849Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.495 27.0605C14.5647 25.0857 14.6009 21.9201 16.5757 19.9899L20.1513 16.495C22.1261 14.5647 25.2917 14.6009 27.2219 16.5757L34.2118 23.727L23.4849 34.2118L16.495 27.0605Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.495 106.061C14.5647 104.086 14.6009 100.92 16.5757 98.9899L23.727 92L34.2118 102.727L27.0605 109.717C25.0857 111.647 21.9201 111.611 19.9899 109.636L16.495 106.061Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100.485L102.727 90L109.717 97.1513C111.647 99.1261 111.611 102.292 109.636 104.222L106.061 107.717C104.086 109.647 100.92 109.611 98.9899 107.636L92 100.485Z",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 17,
    transform: "rotate(25.3878 63 63)",
    stroke: "#D9D9D9",
    strokeWidth: 14
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3911 35.9891C71.8647 34.9912 73.0575 34.5662 74.0554 35.0397L76.7657 36.326C77.7636 36.7995 78.1886 37.9924 77.7151 38.9903L75.5714 43.5074L69.2474 40.5062L71.3911 35.9891Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7547 48.3309C37.2283 47.333 38.4211 46.908 39.419 47.3815L43.9362 49.5252L40.935 55.8492L36.4178 53.7055C35.4199 53.2319 34.9949 52.0391 35.4685 51.0412L36.7547 48.3309Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4938 69.2473L90.0109 71.391C91.0088 71.8646 91.4339 73.0575 90.9603 74.0554L89.6741 76.7656C89.2005 77.7635 88.0076 78.1886 87.0097 77.715L82.4926 75.5713L85.4938 69.2473Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5434 51.9211L88.4073 50.2503C89.452 49.8915 90.5897 50.4474 90.9486 51.4921L91.9697 54.4645C92.3285 55.5091 91.7726 56.6469 90.7279 57.0057L85.864 58.6765L83.5434 51.9211Z",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2072 37.6837C49.8483 36.6391 50.4043 35.5013 51.4489 35.1425L54.4213 34.1214C55.4659 33.7626 56.6037 34.3185 56.9625 35.3632L58.6334 40.2271L51.878 42.5476L50.2072 37.6837Z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0782 71.67C33.7194 70.6253 34.2753 69.4875 35.32 69.1287L40.1839 67.4579L42.5044 74.2133L37.6406 75.8841C36.5959 76.2429 35.4581 75.687 35.0993 74.6423L34.0782 71.67Z",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8228 85.0469L74.5782 82.7263L76.2491 87.5902C76.6079 88.6348 76.052 89.7726 75.0073 90.1315L72.0349 91.1525C70.9903 91.5114 69.8525 90.9554 69.4937 89.9108L67.8228 85.0469Z",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5252 82.0638L55.8492 85.065L53.7055 89.5822C53.2319 90.5801 52.0391 91.0051 51.0412 90.5315L48.3309 89.2453C47.333 88.7717 46.9079 87.5789 47.3815 86.581L49.5252 82.0638Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Versn);
export default __webpack_public_path__ + "static/media/6versn.992eff16afe4b791139abf310ec749b3.svg";
export { ForwardRef as ReactComponent };